import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import api from '../lib/api';

const AddWidgetForm = ({ onWidgetCreated }) => {
  const [site, setSite] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!site.trim()) {
      setError('Site domain is required');
      return;
    }

    setLoading(true);

    try {
      const res = await api.post('/admin/widgets/', { site, name });
      if (res.status >= 200 && res.status < 300) {
        setSuccess(true);
        setSite('');
        setName('');
        onWidgetCreated && onWidgetCreated();
      } else {
        setError('Failed to add widget');
      }
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || 'Failed to add widget';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} className="mb-4 shadow-sm p-3 border rounded">
      <h6>Add New Widget</h6>
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">Widget created successfully!</Alert>}

      <Form.Group className="mb-2">
        <Form.Label>Site Domain (e.g., mysite.com)</Form.Label>
        <Form.Control
          type="text"
          value={site}
          onChange={(e) => setSite(e.target.value)}
          placeholder="Enter domain"
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Friendly Name (optional)</Form.Label>
        <Form.Control
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. My Company Chat"
        />
      </Form.Group>

      <Button type="submit" disabled={loading} style={{ cursor: 'pointer' }}>
        {loading ? <Spinner animation="border" size="sm" /> : 'Create Widget'}
      </Button>
    </Form>
  );
};

export default AddWidgetForm;
